import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// Removed withRouter import
// import { withRouter } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import {
	SettingOutlined
} from '@ant-design/icons';
import Icon from '@ant-design/icons';
import { ReactComponent as DashboardSvg } from '../../static/dashboard.svg';
import { ReactComponent as FactorySvg } from '../../static/factory.svg';
import { ReactComponent as DeviceSvg } from '../../static/device.svg';
import { ReactComponent as ReportSvg } from '../../static/report.svg';
import { ReactComponent as FinanceSvg } from '../../static/finance.svg';
import { ReactComponent as AnalysisSvg } from '../../static/analysis.svg';
import './sidenav.css';

import {
	userLogout,
	userSideNav,
	appTitleUpdate
} from '../../modules/user';


// import userImg from '../static/logo_dark.png';
import userImgMin from '../../static/deca-vpp-logo.png';


const navItems = [
	{ key: '/', label: 'Dashboard', icon: <Icon component={DashboardSvg} /> },
	{ key: '/sites', label: 'Sites', icon: <Icon component={FactorySvg} /> },
	{ key: '/devices', label: 'Devices', icon: <Icon component={DeviceSvg} /> },
	{ key: '/reports', label: 'Reports', icon: <Icon component={ReportSvg} /> },
	{ key: '/finance', label: 'Finance', icon: <Icon component={FinanceSvg} /> },
	{ key: '/analysis', label: 'Analysis', icon: <Icon component={AnalysisSvg} /> },
	{ key: '/settings', label: 'Settings', icon: <SettingOutlined /> },
];

class SideNav extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userModal: false,
			openKeys: []
		}
		this.navigate = props.navigate;
		this.location = props.location;
	}

  componentDidMount() {
		const { location } = this.props;
		this.props.appTitleUpdate({});
//		document.title = `Carbon Zero`;
	}

	componentDidUpdate(prevProps) {
		const { location } = this.props;
		if(location !== prevProps.location){
			this.props.appTitleUpdate({});
//			document.title = `Carbon Zero`;
		}
  }

	toggleUserModal = () => {
		const { userModal } = this.state;
		this.setState({ userModal: !userModal });
	}

	onGoUser() {
		this.navigate('/settings');
	}

	toggleSideNav = () => {
		const { userNav } = this.props;
		this.props.userSideNav(userNav);
	}

	onOpenChange = keys => {
		var { openKeys} = this.state;
		const rootSubmenuKeys = ['Dashboard', 'VideoPlayerManagement', 'CDNManagement', 'AccessManagement'];
		const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
		if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
			this.setState({ openKeys: keys });
		} else {
			this.setState({ openKeys: latestOpenKey ? [latestOpenKey] : [] });
		}
	};

	render() {
		const { userProfile} = this.props;
		const { location } = this.props;
		let { openKeys} = this.state;
		const classSideNav = (this.props.userNav) ? 'sideNavWrapper sideNavWrapperForce' : 'sideNavWrapper';

		if (this.props.userAuthenticated && userProfile.user) {
			return (
				<div>
				<div className={classSideNav}>
					<h1>
						<div
							className="logoHolder fullIcon"
						/>
					</h1>
					<ul className={`navList ${this.props.userNav ? 'collapsed' : ''}`}>
            {navItems.map(item => (
              <li
                key={item.key}
                className={`navItem ${location.pathname === item.key ? 'active' : ''}`}
                onClick={() => this.navigate(item.key)}
              >
                <span className="icon">{item.icon}</span>
                {!this.props.userNav && <span className="label">{item.label}</span>}
              </li>
            ))}
          </ul>

				</div>
				</div>
			);
		}

		return (<div>&nbsp;</div>);
	}

}
//<span className="logout"><a onClick={() => this.onLogout()}><LogoutOutlined style={{ marginRight: '10px' }} />Logout</a></span>

const mapStateToProps = state => ({
	router: state.router,
	userAuthenticated: state.user.userAuthenticated,
	userProfile: state.user.userProfile,
	userNav: state.user.userNav
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			userLogout,
			userSideNav,
			appTitleUpdate
		},
		dispatch
	);


function SideNavWithRouter(props) {
  const location = useLocation();
  const navigate = useNavigate();
  return <SideNav {...props} location={location} navigate={navigate} />;
}

export default connect(mapStateToProps, mapDispatchToProps)(SideNavWithRouter);
